module.exports = __webpack_public_path__ + "static/05-ad45278b6ac5f5d40f30c3983350bab8.jpeg";